import { ChangeDetectionStrategy, Component } from '@angular/core';
import { JsonLdService, MetaService } from '@app/core';
import {
  AppflowSectionComponent,
  ComplianceSectionComponent,
  CustomerLogoSectionComponent,
} from '@app/widgets';
import { ENTERPRISE_FAQS } from '../../constants';
import {
  EnterpriseCtaSectionComponent,
  EnterpriseFaqSectionComponent,
  EnterpriseFeaturesSectionComponent,
  EnterpriseHeroSectionComponent,
  EnterpriseScalabilitySectionComponent,
  EnterpriseSecuritySectionComponent,
  EnterpriseSupportSectionComponent,
} from '../index';

@Component({
  selector: 'app-enterprise',
  imports: [
    AppflowSectionComponent,
    ComplianceSectionComponent,
    CustomerLogoSectionComponent,
    EnterpriseHeroSectionComponent,
    EnterpriseFeaturesSectionComponent,
    EnterpriseScalabilitySectionComponent,
    EnterpriseSecuritySectionComponent,
    EnterpriseSupportSectionComponent,
    EnterpriseFaqSectionComponent,
    EnterpriseCtaSectionComponent,
  ],
  templateUrl: './enterprise.component.html',
  styleUrl: './enterprise.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnterpriseComponent {
  constructor(
    private readonly metaService: MetaService,
    private readonly jsonLdService: JsonLdService,
  ) {
    this.metaService.setDescription(
      'Build, update, and publish your Capacitor apps at enterprise scale with Live Updates, Native Builds, and App Store Publishing. Enterprise-grade security, scalability, and support.',
    );
    this.metaService.setTitle('Enterprise');
    this.metaService.setKeywords([
      'Capacitor enterprise',
      'enterprise mobile development',
      'custom plans',
    ]);
    this.jsonLdService.setStructuredData([
      JsonLdService.buildWebPageSchema(
        'Enterprise - Capawesome Cloud',
        'Build, update, and publish your Capacitor apps at enterprise scale.',
        'https://cloud.capawesome.io/enterprise/',
      ),
      JsonLdService.buildFaqSchema(ENTERPRISE_FAQS),
    ]);
  }
}
